import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { makeSelectEventTypeFilterContent } from '../selectors';
import { setEventTypeFilterDataArray, setEventTypeFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import initialStateConstants from '../initialStateConstants';

/**
 * Applies the ?event_type= query parameter once the filter items are loaded.
 *
 * Unlike the degree filter there is no Drupal-side pre-set for the event type,
 * so the URL is the only source here. Mirrors SearchNiveau/PreFilter.js.
 */
export const EventTypePreFilter = ({ eventTypeItems, onSetEventTypeFilterId, onSetEventTypeFilterDataArray }) => {
  const appHistory = useHistory();
  const { search } = useLocation();
  const [queryParams, setQueryParams] = useState(queryString.parse(search)?.event_type ?? '');

  useEffect(() => {
    if (queryParams.length > 0) {
      preFilter(queryParams);
    }
  }, [eventTypeItems]);

  useEffect(() => {
    let newQueryString = queryString.parse(search)?.event_type ?? '';
    if (newQueryString === queryParams) {
      return null;
    }
    if (appHistory.action === 'POP') {
      preFilter(newQueryString);
    }
    setQueryParams(newQueryString);
  }, [search]);

  const preFilter = (newQueryString) => {
    if (eventTypeItems.length === 0) {
      return null;
    }
    const filterItems = newQueryString.length > 0 ? newQueryString.split('_') : [];
    if (filterItems.length === 0) {
      resetFilter();
      return null;
    }
    // Unknown keys are dropped — an old link must not filter on a value the
    // field no longer allows.
    const known = filterItems.filter((currentItem) =>
      eventTypeItems.some((item) => Object.keys(item)[0] === currentItem),
    );
    if (known.length === 0) {
      resetFilter();
      return null;
    }
    onSetEventTypeFilterId(known);
    onSetEventTypeFilterDataArray(
      known.map((currentItem) => {
        const result = eventTypeItems.find((item) => Object.keys(item)[0] === currentItem);
        return result[Object.keys(result)].name;
      }),
    );
  };

  const resetFilter = () => {
    onSetEventTypeFilterId(initialStateConstants.eventTypeFilterId);
    onSetEventTypeFilterDataArray(initialStateConstants.eventTypeFilterDataArray);
  };

  return <></>;
};

EventTypePreFilter.propTypes = {
  eventTypeItems: PropTypes.array,
  onSetEventTypeFilterId: PropTypes.func,
  onSetEventTypeFilterDataArray: PropTypes.func,
};

EventTypePreFilter.defaultProps = {
  eventTypeItems: [],
  onSetEventTypeFilterId: () => {},
  onSetEventTypeFilterDataArray: () => {},
};

const mapStateToProps = createStructuredSelector({
  eventTypeItems: makeSelectEventTypeFilterContent(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetEventTypeFilterId: (value) => dispatch(setEventTypeFilterId(value)),
    onSetEventTypeFilterDataArray: (value) => dispatch(setEventTypeFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(EventTypePreFilter);
